import { useCallback, useEffect } from 'react'
import {
  FinanceFormInput,
  useSimulationInfoLazyQuery,
} from '../../common/graphql/__generated__/graphql.autogenerated'
import { SimulationInfo } from '../components/widgetButton/MiniFcWidgetButton'

// TODO fix react hook linting error exhaustive-deps
/* eslint-disable react-hooks/exhaustive-deps */
export const useSimulationInfoQuery = (
  setIsCash: (value: React.SetStateAction<boolean>) => void,
  setSimulationData: React.Dispatch<React.SetStateAction<SimulationInfo | null>>
) => {
  const [getSimulationInfo, simulationResult] = useSimulationInfoLazyQuery({
    fetchPolicy: 'no-cache',
  })

  const querySimulationInfo = useCallback(
    (codes: string[], financeFormInput: FinanceFormInput | null) => {
      return getSimulationInfo({
        variables: {
          codes,
          financeFormInput,
        },
      })
    },
    []
  )

  useEffect(() => {
    const { data, loading, error } = simulationResult

    if (!loading && error) {
      setIsCash(true)
    }

    if (!loading && !error && data) {
      const simulation = data.finance?.simulationInfo[0]?.result?.simulation
      if (simulation && simulation.paymentValue?.length) {
        const paymentValue = simulation?.paymentValue[0]
        if (paymentValue && paymentValue.amount && simulation.frequency) {
          setSimulationData({
            amount: paymentValue.amount,
            frequency: simulation.frequency,
          })
        }
      }
    }
  }, [simulationResult.loading, simulationResult.data])

  return { querySimulationInfo, loading: simulationResult.loading }
}
